import usePaymentContext from './hook/usePaymentContext'
import PaymentDetailUI from './PaymentDetailUI'

interface PaymentDetailProps {
    onSubmit: () => void
}
export function PaymentDetail({ onSubmit }: PaymentDetailProps) {
    const {
        selectedPaymentType,
        tenderedAmount,
        expectAmount,
        payment,
        paymentTypeLists: paymentSettings,
        isReadyToProceedPayment,
        tipsAmount,
        clearTips,
        redeemDiscount,
        orderDetail,
        onClickCustomer,
        resetPaymentStatus,
        resetEvoPaymentDialogState,
        orderCustomerID,
        hasAwaitingProcessTransaction,
    } = usePaymentContext()
    return (
        <PaymentDetailUI
            paymentSettings={paymentSettings}
            payment={payment}
            selectedPaymentType={selectedPaymentType}
            isReadyToProceedPayment={isReadyToProceedPayment}
            expectAmount={expectAmount}
            tenderedAmount={tenderedAmount}
            orderNumber={orderDetail?.orderNo ?? ''}
            onSubmit={onSubmit}
            tipsAmount={tipsAmount.toNumber()}
            clearTips={clearTips}
            redeemDiscount={redeemDiscount}
            onClickCustomer={onClickCustomer}
            disabledUpdateCustomer={hasAwaitingProcessTransaction}
            hasAwaitingProcessTransaction={hasAwaitingProcessTransaction}
            customerID={orderCustomerID}
            resetPaymentStatus={resetPaymentStatus}
            onCancelEvoPaymentDialog={resetEvoPaymentDialogState}
        />
    )
}
